import styled from "styled-components";

const LoginBannerStyle = styled.div`
  display: grid;
  grid-template-rows: 1fr auto 1fr;
  align-content: space-between;
  height: 100%;
  box-sizing: border-box;
  padding: 24px 32px;

  img {
    justify-self: center;
  }

  .footer {
    text-align: center;
    align-self: center;
  }

  @media (max-width: 800px) {
    display: none;
  }
`;

export default LoginBannerStyle;
